module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/profit-dev/src/app/theme/layouts/layout/layout.component.html
// module id = ../../../../../src/app/theme/layouts/layout/layout.component.html
// module chunks = main